import React from "react";
import { Tabs, Tab, Box } from "@mui/material";

const CommonTabs = ({ tabs, value, onChange }) => {
  return (
    <Box className="stepper-tabs-wrapper">
    <Tabs
      value={value}
      onChange={(e, newValue) => onChange(newValue)}
      variant="fullWidth"
      TabIndicatorProps={{
        style: {
          height: 1,
          borderRadius: 2
        }
      }}
    >
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          label={tab.label}
          sx={{
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 600,
            minHeight: 50,
          }}
        />
      ))}
    </Tabs>
  </Box>
  );
};

export default CommonTabs;